import { useContext } from 'react';
import { SessionContext } from '../state/Session';
import UserRoles from '../types/UserRoles';

export const useStaffCostAccess = () => {
  const sessionContext = useContext(SessionContext) as any;
  const roles = (sessionContext.session?.user?.metadata ?? []) as string[];
  const isSuperAdmin = roles.indexOf(UserRoles.SuperAdmin) >= 0;
  const staffCostAccess = sessionContext.session?.account?.metadata?.staffCostAccess;

  return isSuperAdmin || staffCostAccess;
};

export default useStaffCostAccess;
